import React, { useState } from 'react';
import {
  MDBBtn,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBModalFooter,
  MDBInput,
} from 'mdb-react-ui-kit';

const SaveFilterModal = ({ showSaveFilterModal, setShowSaveFilterModal }) => {
  
  return (
    <>
      <MDBModal show={showSaveFilterModal} onClose={() => setShowSaveFilterModal(false)} staticBackdrop tabIndex='-1' >
        <MDBModalDialog scrollable>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>Save list</MDBModalTitle>
              <MDBBtn
                className='btn-close'
                color='none'
                onClick={() => setShowSaveFilterModal(false)}
              ></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>
              <MDBInput label="Save List" id="form1" type="text" />
            </MDBModalBody>
            <MDBModalFooter>
              <MDBBtn color='secondary' onClick={() => setShowSaveFilterModal(false)}>
                Close
              </MDBBtn>
              <MDBBtn className='shadow-none'>
                Save
              </MDBBtn>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </>
  );
}

export default SaveFilterModal;